<template>
  <v-card-title class="dialog-header d-flex flex-row align-baseline">

      <div class="title-text">{{ title }}</div>
      <div class="ml-auto">
        <v-btn v-if="close"
               icon
               @click.stop="close"
               :title="$t('actions.close')"
               >
          <v-icon color="white">mdi-close</v-icon>
        </v-btn>
      </div>

  </v-card-title>
</template>

<script>
export default {
  name: 'DialogHeader',
  props: {
    close: {
      type: Function,
    },
    title: {
      type: String,
      required: true,
    },
  },
};
</script>

<style scoped>
.dialog-header {
  flex-wrap: nowrap;
  background-color: var(--v-primary-base);
  color: #fff;
  font-weight: 400;
}

.dialog-header .title-text{
  word-break: break-word;
}
</style>
